"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagerNavbar = void 0;
const auth_1 = require("firebase/auth");
const firestore_1 = require("firebase/firestore");
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const Badge_1 = __importDefault(require("react-bootstrap/Badge"));
const Nav_1 = __importDefault(require("react-bootstrap/Nav"));
const Navbar_1 = __importDefault(require("react-bootstrap/Navbar"));
const react_router_dom_1 = require("react-router-dom");
const authContext_1 = require("../../context/authContext");
const configContext_1 = require("../../context/configContext");
const bookingQueries_1 = require("../../models/queries/bookingQueries");
const useFirestore_1 = require("../../utils/useFirestore");
const IconEdit_1 = require("../icons/IconEdit");
const IconPeople_1 = require("../icons/IconPeople");
const IconPerson_1 = require("../icons/IconPerson");
const IconPowerSettingsNew_1 = require("../icons/IconPowerSettingsNew");
const IconSwapHorizontal_1 = require("../icons/IconSwapHorizontal");
require("./ManagerNavbar.scss");
const ManagerNavbar = (props) => {
    var _a, _b, _c, _d, _e;
    const config = (0, configContext_1.useConfig)();
    const firestore = (0, useFirestore_1.useFirestore)();
    const [auth, authInfo] = (0, authContext_1.useAuth)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const [confirmCount, setConfirmCount] = (0, react_1.useState)();
    const [invoiceCount, setInvoiceCount] = (0, react_1.useState)();
    /** Navbar expanded state. */
    const [expanded, setExpanded] = (0, react_1.useState)(false);
    /** Init counters. */
    (0, react_1.useEffect)(() => {
        const unsubscribeConfirmCount = (0, firestore_1.onSnapshot)((0, bookingQueries_1.bookingQueryAllToConfirm)(firestore, config.tenantId), (querySnapshot) => {
            setConfirmCount(querySnapshot.size);
        }, (err) => {
            console.error(err);
        });
        const unsubscribeInvoiceCount = (0, firestore_1.onSnapshot)((0, bookingQueries_1.bookingQueryAllToInvoice)(firestore, config.tenantId), (querySnapshot) => {
            setInvoiceCount(querySnapshot.size);
        }, (err) => {
            console.error(err);
        });
        return () => {
            unsubscribeConfirmCount();
            unsubscribeInvoiceCount();
        };
    }, []);
    function closeDropdown() {
        document.body.click();
    }
    function closeMenu() {
        setExpanded(false);
    }
    return (react_1.default.createElement(Navbar_1.default, { className: "manager-navbar", bg: "dark", variant: "dark", expand: "lg", sticky: "top", expanded: expanded },
        react_1.default.createElement("div", null,
            react_1.default.createElement(Navbar_1.default.Toggle, { "aria-controls": "manager-navbar-nav", className: "mr-3", onClick: () => setExpanded(!expanded) }),
            react_1.default.createElement(Navbar_1.default.Brand, { onClick: () => {
                    navigate(`/manager/${config.tenantId}/`);
                    closeMenu();
                } }, "Benjibooks")),
        react_1.default.createElement(Navbar_1.default.Collapse, { id: "manager-navbar-nav" },
            react_1.default.createElement(Nav_1.default, { className: "d-flex w-100" },
                react_1.default.createElement("div", { className: "flex-grow-1 d-lg-flex" },
                    react_1.default.createElement(react_router_dom_1.NavLink, { to: `/manager/${config.tenantId}/`, end: true, className: "nav-link", onClick: closeMenu }, "Tages\u00FCbersicht"),
                    react_1.default.createElement(react_router_dom_1.NavLink, { to: `/manager/${config.tenantId}/calendar/`, className: "nav-link", onClick: closeMenu }, "Kalender"),
                    (((_a = authInfo.user) === null || _a === void 0 ? void 0 : _a.isAdminOf(config.tenantId)) ||
                        ((_b = authInfo.user) === null || _b === void 0 ? void 0 : _b.isSuperadmin)) && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(react_router_dom_1.NavLink, { to: `/manager/${config.tenantId}/confirm/`, className: "nav-link", onClick: closeMenu },
                            "Best\u00E4tigen",
                            " ",
                            react_1.default.createElement(Badge_1.default, { pill: true, variant: "secondary" }, confirmCount !== null && confirmCount !== void 0 ? confirmCount : "..")),
                        react_1.default.createElement(react_router_dom_1.NavLink, { to: `/manager/${config.tenantId}/invoice/`, className: "nav-link", onClick: closeMenu },
                            "Fakturieren",
                            " ",
                            react_1.default.createElement(Badge_1.default, { pill: true, variant: "secondary" }, invoiceCount !== null && invoiceCount !== void 0 ? invoiceCount : "..")),
                        react_1.default.createElement(react_router_dom_1.NavLink, { to: `/manager/${config.tenantId}/payments/`, className: "nav-link", onClick: closeMenu }, "Zahlungen"),
                        react_1.default.createElement(react_router_dom_1.NavLink, { to: `/manager/${config.tenantId}/report/`, className: "nav-link", onClick: closeMenu }, "Auswertung"),
                        react_1.default.createElement(react_router_dom_1.NavLink, { to: `/manager/${config.tenantId}/addons/`, className: "nav-link", onClick: closeMenu }, "Addons")))))),
        react_1.default.createElement(Nav_1.default, { className: "manager-nav-user" },
            react_1.default.createElement(react_bootstrap_1.NavDropdown, { title: react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(IconPerson_1.IconPerson, null),
                    " ",
                    react_1.default.createElement("span", null, config.name)), id: "manager-nav-user-dropdown" },
                react_1.default.createElement(react_bootstrap_1.NavDropdown.Header, null,
                    react_1.default.createElement("div", null, authInfo.user.name),
                    react_1.default.createElement("div", null, authInfo.user.email)),
                react_1.default.createElement(react_router_dom_1.Link, { to: `/manager/${config.tenantId}/users/me/`, onClick: closeDropdown, className: "dropdown-item" },
                    react_1.default.createElement(IconEdit_1.IconEdit, null),
                    " Profil editieren"),
                (((_c = authInfo.user) === null || _c === void 0 ? void 0 : _c.isAdminOf(config.tenantId)) ||
                    ((_d = authInfo.user) === null || _d === void 0 ? void 0 : _d.isSuperadmin)) && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(react_router_dom_1.Link, { to: `/manager/${config.tenantId}/users/`, onClick: closeDropdown, className: "dropdown-item" },
                        react_1.default.createElement(IconPeople_1.IconPeople, null),
                        " Benutzer verwalten"))),
                react_1.default.createElement(react_bootstrap_1.NavDropdown.Divider, null),
                (authInfo.user.memberOf.length > 1 ||
                    ((_e = authInfo.user) === null || _e === void 0 ? void 0 : _e.isSuperadmin)) && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(react_router_dom_1.Link, { to: "/manager/", className: "dropdown-item" },
                        react_1.default.createElement(IconSwapHorizontal_1.IconSwapHorizontal, null),
                        " Mandant wechseln"),
                    react_1.default.createElement(react_bootstrap_1.NavDropdown.Divider, null))),
                react_1.default.createElement(react_bootstrap_1.NavDropdown.Item, { onClick: () => (0, auth_1.signOut)(auth) },
                    react_1.default.createElement(IconPowerSettingsNew_1.IconPowerSettingsNew, null),
                    " Abmelden")))));
};
exports.ManagerNavbar = ManagerNavbar;
